import React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

export const TriToggle = ({ values, form, options, name, selectedSlide }) => {

  const Div = styled.div`
    
    &.is-selected {
      background-color: red;
    }
  `;

  const Span = styled.span`
    background-color: #f4d29e;
    display: inline-block;
    padding: 2px;
    width: 20px;
    height: 20px;
    vertical-align: -5px;
    
    &.is-selected {
      background-color: white;
    }
    
    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      margin-left: 5px;
    }
    
      &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      margin-right: 5px;
    }
  `;

  return (
      <Div>
        { options[0].name }
        { options.map((option, index) => (
            <Span key={ index }
                  onClick={ () => form.setFieldValue(`slides.${selectedSlide}.layout.device`, option.value)  }
                  className={ classnames(['', {['is-selected']: option.value === values.slides[selectedSlide].layout.device } ]) }
                  style={ { display: 'inline-block' } }
            >
            </Span>))
        }
        { options[2].name }
      </Div>
  )
};



// WEBPACK FOOTER //
// ./src/components/TriToggle/TriToggle.js